import React from "react";
import { FormFeedback, FormGroup, Input, Label} from "reactstrap";
import { Tooltip } from 'react-tooltip'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";


var moment = require('moment')

class Parent extends React.Component{
    constructor(props) {
        super(props);
        this.state ={
            age:localStorage.getItem("Age"),
            NotValid :{},
            stored: {},
            firstname : {},
            name: {},
            birthdate: {},
            isCharge: {},
            isCohabitant: {},
            isPartialCohabitant: {},
            cohabitantDetail: {},
            birthdateEarlierError : {},
            birthdateError : {},
            birthdateFormatError : {},
            openForm:true,

        }
        this.AgeCalculation = this.AgeCalculation.bind(this)
        this.handleChangePar = this.handleChangePar.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.toggleForm = this.toggleForm.bind(this)
    }

    // fetch data from local Storage
    componentDidMount() {
        let {index} = this.props
        let storedParent = JSON.parse(localStorage.getItem("parent"))
      //console.log(storedParent)
        if (storedParent && storedParent[index]){
          //console.log(storedParent)
            let par = storedParent[index]
          //console.log(par)
             let partialState = {...this.state};
             for ( const [name,value] of Object.entries(par) ){
               //console.log(name)
                 partialState[name][index] = value;
             }
            partialState["stored"][index] = true
            partialState["age"] = parseInt(localStorage.getItem("Age"))
             this.setState(partialState);
             this.setState({openForm:false})
        }
    }

    AgeCalculation(e)  {
      //console.log(e)

            const {index} = this.props
          //console.log(e.target.value)
            let birthDate = moment(e.target.value, "YYYY-MM-DD")
            let validDate = moment(birthDate, 'YYYY-MM-DD', true).isValid()
            //console.log(Field283Birthdate)
            if (validDate) {
                let pastDate = birthDate.isBefore(moment())
                let partialState = {...this.state};
                partialState["birthdateFormatError"][index] = false;
                this.setState(partialState);
                this.setState(
                )
                if (!pastDate) {
                    let partialState = {...this.state};
                    partialState["birthdateError"][index] = true;
                    partialState["birthdateEarlierError"][index] = true;
                    this.setState(partialState);
                }else{
                    let partialState = {...this.state};
                    partialState["birthdateError"][index] = false;
                    partialState["birthdateEarlierError"][index] = false;
                    this.setState(partialState);
                    //console.log(birth)
                    //console.log(Age)
                }
            }
    }

    toggleForm(e){
        e.preventDefault()
        this.setState({openForm: !this.state.openForm})
    }

    handleChangePar(e){
        const {index} = this.props
        const target = e.target;
        const value = target.value;
        const name = e.target.type === "radio"? target.name.replace(/[0-9]/g, '') : target.name;
        //console.log()
        if (e.target.name === "birthdate"){
            this.AgeCalculation(e)
        }

        let partialState = {...this.state};
        partialState[name][index] = value;
        this.setState(partialState);
        //let sl = par.filter((l, k) => l.label !== '')
        //console.log(sl)
    }

    handleSubmit(evt) {
        evt.preventDefault();
        const {index} = this.props
        let notValid = this.state.NotValid
        notValid[index] = this.state.birthdate[index] === "" || this.state.firstname[index] === ""|| this.state.name[index] === ""|| this.state.isCharge[index] === ""
      //console.log(notValid[index])
        this.setState({NotValid:notValid})
      //console.log(this.state.NotValid[index])
        if (!this.state.NotValid[index]){
            let parObject
            parObject = {
                birthdate : this.state.birthdate[index],
                firstname : this.state.firstname[index],
                name : this.state.name[index],
                isCharge : this.state.isCharge[index]
            }
            //console.log(parObject)
            this.props.submitPar(this.props.index, parObject)
            this.setState({openForm:false, stored:true})
            //console.log(JSON.parse(stringInfo))
        }
    }

    delete(evt,index){
        evt.preventDefault()
        this.props.delete(index);
    }
    render() {
        const {i18n, index, d} = this.props;
        return (
            <div>
                {!this.state.openForm &&
                <div className={"formlevel02"}>
                <p><strong>{i18n.t("FIRSTNAMEPARENTS")} :</strong> {this.state.firstname[index]} </p>
                <p><strong>{i18n.t("NAMEPARENTS")} :</strong> {this.state.name[index]} </p>
                <p><strong>{i18n.t("BIRTHDATEDATA")} :</strong> {moment(this.state.birthdate[index]).format('l')} </p>
                <p><strong>{this.state.age < 16 ?<span> {d ? i18n.t("field294ChargeDeathInverse"): i18n.t("field294ChargeInverse")}</span> : <span> {d ? i18n.t("field294ChargeDeath"): i18n.t("field294Charge")}</span>} :</strong> {this.state.isCharge[index]} </p>
                    <div className="button-wrapper text-right">
                        <button type="submit" onClick={this.toggleForm}
                                className="btn btn-primary small mr-1">{i18n.t("METTRE A JOUR CES INFORMATIONS")}</button>

                        <button type="submit" onClick={e=>this.delete(e,index)}
                                className="btn btn-outline small auto">&nbsp;<FontAwesomeIcon icon={['fas', 'trash']} />&nbsp;</button>
                    </div>
                </div>
                }
                {this.state.openForm &&
                <div>
                <div className="formlevel02">
                    <FormGroup className={(this.state.NotValid[index] && this.state.firstname[index] === "") ? "text-danger" : "text"}>
                        <Label htmlFor={"firstname"}>{i18n.t("FIRSTNAMEPARENTS")} <span className={"text-danger"}>*</span></Label>
                        <Input type="text" maxLength={500} id={"firstname"}
                               value={this.state.firstname[index]? this.state.firstname[index]: ''}
                               name="firstname" onChange={e=>this.handleChangePar(e)} placeholder={d?i18n.t("PLACEHOLDERFIRSTNAMEPARENTSDEATH"):i18n.t("PLACEHOLDERFIRSTNAMEPARENTS")}
                               invalid={(this.state.NotValid[index] && this.state.firstname[index] === "")} />
                        {(this.state.NotValid[index] && this.state.firstname[index] === "") && <span className="help-block form-error">{i18n.t("Obligatoire")}</span>}
                    </FormGroup>
                    <FormGroup className={(this.state.NotValid[index] && this.state.name[index] === "")? "text-danger" : "text"}>
                        <Label htmlFor={"name"}
                        >{i18n.t("NAMEPARENTS")} </Label><span className={"text-danger"}>*</span>
                        <Input type="text" maxLength={500} id={"name"} name="name"
                               placeholder={d? i18n.t("PLACEHOLDERNAMEPARENTSDEATH"): i18n.t("PLACEHOLDERNAMEPARENTS") }
                               value={this.state.name[index]? this.state.name[index]: ''}
                               onChange={e=>this.handleChangePar(e)}
                               invalid={(this.state.NotValid[index] && this.state.name[index] === "")}/>
                        <FormFeedback>{i18n.t("Obligatoire")}</FormFeedback>
                    </FormGroup>
                    <FormGroup className={((this.state.birthdateError[index]) || (this.state.birthdateEarlierError[index]) || (this.state.birthdateFormatError[index]))? "text-danger" : "text"}>
                        <Label for={"birthdate"}>{i18n.t("BIRTHDATEDATA")} <span className={"text-danger"}>*</span></Label>
                        <Input name={"birthdate"} onChange={e=>this.handleChangePar(e)} type="date" id={"birthdate"} value={this.state.birthdate[index]? this.state.birthdate[index]: ''} invalid={(this.state.NotValid[index] && this.state.birthdate[index] === "")}/>
                        <FormFeedback>{  i18n.t('Obligatoire') }</FormFeedback>
                        {this.state.birthdateEarlierError[index] && <p>{i18n.t("La date doit être dans le passé")}</p>}
                        {this.state.birthdateFormatError[index] && <p>{i18n.t("La date n'est pas correctement encodée")} : {i18n.t("jj/mm/yyyy")} </p>}
                    </FormGroup>
                    <FormGroup className={(this.state.NotValid[index] && this.state.isCharge[index] === "")? "text-danger" : "text"} check>
                        <Label htmlFor={"isCharge"}>{this.state.age < 16 ?<span> {d ? i18n.t("field294ChargeDeathInverse"): i18n.t("field294ChargeInverse")}</span> : <span> {d ? i18n.t("field294ChargeDeath"): i18n.t("field294Charge")}</span>} <span className={"text-danger"}>*</span>{this.state.age > 16 &&<span><span className={"question"} data-tip={i18n.t("QUESTIONCHARGE")}>?</span><Tooltip place="right" type="light" multiline={true} effect="solid"/></span>}</Label>
                        <div className="checkbox">
                            <Label>
                                <Input type="radio" name={"isCharge"+[index]}
                                       value="no" onChange={e=>this.handleChangePar(e)} checked={this.state.isCharge[index] === "no"} />
                                {i18n.t("NO")}
                            </Label>
                        </div>
                        <div className="checkbox">
                            <Label>
                                <Input type="radio" name={"isCharge"+[index]}
                                       value="yes" onChange={e=>this.handleChangePar(e)} checked={this.state.isCharge[index] === "yes"} />
                                {i18n.t("YES")}
                            </Label>
                        </div>
                        {(this.state.NotValid[index] && this.state.isCharge[index] === "") &&<span className="help-block form-error">{i18n.t("Obligatoire")}</span>}
                    </FormGroup>
                    <div>
                        <button type="submit" onClick={this.handleSubmit}
                                className="btn btn-primary small mr-1">{this.state.stored[index] ? i18n.t("METTRE A JOUR CES INFORMATIONS"): i18n.t("AJOUTER CES INFORMATIONS")}</button>
                    </div>

                </div>
                </div> }
            </div>
        )
    }
}
export default Parent

